<ng-container *ngIf="currentProduct$ | async as currentProduct">
  <ng-container *ngIf="currentProduct.ebProductType === ebProductTypeEnum.PARENT">
    <ng-container *ngIf="pagedVariants$ | async as pagedVariants; else fetchingVariants">
      <div class="product-variants-table" [class.loading]="loading">
        <h2 class="product-variants-table__title">
          {{ 'productVariantList.title' | cxTranslate }}
        </h2>
        <eb-unit-selector></eb-unit-selector>
        <eb-product-variants-filter
          [facets]="searchResult?.facets"
          [numberOfResults]="totalResults"
          [freeTextSearch]="freeTextSearch"
        >
        </eb-product-variants-filter>
        <ng-container *ngIf="pagedVariants.length > 0; else noVariantsFound">
          <cx-table
            [structure]="dataStructure$ | async"
            [data]="pagedVariants"
            [i18nRoot]="'productVariantList'"
            class="product-variants-table__table"
            [attr.data-cy]="'product-variant-list'"
            (launch)="launchItem($event)"
          >
          </cx-table>
        </ng-container>
        <ng-template #noVariantsFound>
          {{ 'productVariantList.noVariantsFound' | cxTranslate }}
        </ng-template>
        <eb-load-more-button
          *ngIf="pagedVariants.length >= 20 && !(pagedVariants.length >= totalResults)"
          [loading]="loading"
          (clicked)="nextPage()"
        >
        </eb-load-more-button>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
<ng-template #fetchingVariants>
  <eb-spinner></eb-spinner>
</ng-template>
